// Auto-generated from fragranceProfiler.csv
// Do not edit manually

import { CSVRow } from '../lib/csvLoader';

export const fragranceProfilerData: CSVRow[] = [
  {
    "Name": "43, 47, 51, 41, 42",
    "answerOptions": "43,47,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "43, 47, 52, 41, 42",
    "answerOptions": "43,47,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "43, 47, 53, 41, 42",
    "answerOptions": "43,47,53,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "43, 47, 54, 41, 42",
    "answerOptions": "43,47,54,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "43, 48, 51, 41, 42",
    "answerOptions": "43,48,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "43, 48, 52, 41, 42",
    "answerOptions": "43,48,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "43, 48, 53, 41, 42",
    "answerOptions": "43,48,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "43, 48, 54, 41, 42",
    "answerOptions": "43,48,54,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "43, 49, 51, 41, 42",
    "answerOptions": "43,49,51,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "43, 49, 52, 41, 42",
    "answerOptions": "43,49,52,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "43, 49, 53, 41, 42",
    "answerOptions": "43,49,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "43, 49, 54, 41, 42",
    "answerOptions": "43,49,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "43, 50, 51, 41, 42",
    "answerOptions": "43,50,51,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "43, 50, 52, 41, 42",
    "answerOptions": "43,50,52,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "43, 50, 53, 41, 42",
    "answerOptions": "43,50,53,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "44, 50, 54, 41, 42",
    "answerOptions": "44,50,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "44, 47, 51, 41, 42",
    "answerOptions": "44,47,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "44, 47, 52, 41, 42",
    "answerOptions": "44,47,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "44, 47, 53, 41, 42",
    "answerOptions": "44,47,53,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "44, 47, 54, 41, 42",
    "answerOptions": "44,47,54,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "44, 48, 51, 41, 42",
    "answerOptions": "44,48,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "44, 48, 52, 41, 42",
    "answerOptions": "44,48,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "44, 48, 53, 41, 42",
    "answerOptions": "44,48,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "44, 48, 54, 41, 42",
    "answerOptions": "44,48,54,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "44, 49, 51, 41, 42",
    "answerOptions": "44,49,51,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "44, 49, 52, 41, 42",
    "answerOptions": "44,49,52,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "44, 49, 53, 41, 42",
    "answerOptions": "44,49,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "44, 49, 54, 41, 42",
    "answerOptions": "44,49,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "44, 50, 51, 41, 42",
    "answerOptions": "44,50,51,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "44, 50, 52, 41, 42",
    "answerOptions": "44,50,52,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "44, 50, 53, 41, 42",
    "answerOptions": "44,50,53,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "44, 50, 54, 41, 42",
    "answerOptions": "44,50,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "45, 47, 51, 41, 42",
    "answerOptions": "45,47,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "45, 47, 52, 41, 42",
    "answerOptions": "45,47,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "45, 47, 53, 41, 42",
    "answerOptions": "45,47,53,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "45, 47, 54, 41, 42",
    "answerOptions": "45,47,54,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "45, 48, 51, 41, 42",
    "answerOptions": "45,48,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "45, 48, 52, 41, 42",
    "answerOptions": "45,48,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "45, 48, 53, 41, 42",
    "answerOptions": "45,48,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "45, 48, 54, 41, 42",
    "answerOptions": "45,48,54,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "45, 49, 51, 41, 42",
    "answerOptions": "45,49,51,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "45, 49, 52, 41, 42",
    "answerOptions": "45,49,52,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "45, 49, 53, 41, 42",
    "answerOptions": "45,49,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "45, 49, 54, 41, 42",
    "answerOptions": "45,49,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "45, 50, 51, 41, 42",
    "answerOptions": "45,50,51,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "45, 50, 52, 41, 42",
    "answerOptions": "45,50,52,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "45, 50, 53, 41, 42",
    "answerOptions": "45,50,53,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "45, 50, 54, 41, 42",
    "answerOptions": "45,50,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "46, 47, 51, 41, 42",
    "answerOptions": "46,47,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "46, 47, 52, 41, 42",
    "answerOptions": "46,47,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "46, 47, 53, 41, 42",
    "answerOptions": "46,47,53,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "46, 47, 54, 41, 42",
    "answerOptions": "46,47,54,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "46, 48, 51, 41, 42",
    "answerOptions": "46,48,51,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "46, 48, 52, 41, 42",
    "answerOptions": "46,48,52,41,42",
    "fetiche": "1",
    "opulence": "5",
    "sensuality": "2",
    "mystery": "4",
    "elegance": "8",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "46, 48, 53, 41, 42",
    "answerOptions": "46,48,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "46, 48, 54, 41, 42",
    "answerOptions": "46,48,54,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "19"
  },
  {
    "Name": "46, 49, 51, 41, 42",
    "answerOptions": "46,49,51,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "46, 49, 52, 41, 42",
    "answerOptions": "46,49,52,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "15"
  },
  {
    "Name": "46, 49, 53, 41, 42",
    "answerOptions": "46,49,53,41,42",
    "fetiche": "2",
    "opulence": "1",
    "sensuality": "3",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "42",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "46, 49, 54, 41, 42",
    "answerOptions": "46,49,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "12"
  },
  {
    "Name": "46, 50, 51, 41, 42",
    "answerOptions": "46,50,51,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "46, 50, 52, 41, 42",
    "answerOptions": "46,50,52,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "13"
  },
  {
    "Name": "46, 50, 53, 41, 42",
    "answerOptions": "46,50,53,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "11"
  },
  {
    "Name": "46, 50, 54, 41, 42",
    "answerOptions": "46,50,54,41,42",
    "fetiche": "42",
    "opulence": "1",
    "sensuality": "2",
    "mystery": "6",
    "elegance": "4",
    "alsoLikeFetiche": "1",
    "alsoLikeLoubiworld": "11"
  }
];
